import React, { useEffect, useState } from "react";
import { parseISO, addDays, format, formatISO } from 'date-fns';
import { v4 as uuidv4 } from 'uuid';

// primeReact
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Tag } from 'primereact/tag';
// context
import { useContextSimulator } from "../../SimulatorContext";
import { formatCurrency } from "../../../../../../utils/formatCurrency";
import { toast } from "react-toastify";
import Input from "../../../../../../components/input/Input";

const EntryInstallments = () => {
  const {
    minEntryValue,
    entryRange,
    setSelectedEntryTerm,
    entryParcelValue,
    setFirstEntryParcelDate,
    setOthersEntryParcelDate,
    calculatePricePayments,
    entryValue,
    selectedEntryTerm,
    simulatorData,
    selectedPricingTable,
    setEntryParcelsTable,
    firstEntryParcelDate,
    setEntryParcelValue,
    othersEntryParcelDate,
    entryParcelsTableVisible,
    setEntryParcelsTableVisible,
    setEntryRange,
    setEntryValue,
    entryTerms,
    setEntryParcelCalc,
    landValue,
    calculateVPPayments,
    calculateSimpleInterestPayment,
    translatePricingTablesTagToPortuguese,
    setEntryInterest,
    chooseEntry, setChooseEntryInstallments,
    chooseEntryData, setChooseEntryData
  } = useContextSimulator();



  useEffect(() => {
    if (simulatorData) {
      const fetchEntryValues = async () => {
        if (entryValue && selectedEntryTerm) {
          const entryParcel = entryValue;
          const currentTax = simulatorData.entrance_rate / 100;
          //          console.log("Entry TAX: ", currentTax);
          /* simulatorData.installments_interest_entry if true, valor das parcelas será exibido com 
          os juros cadastrados, caso esteja desabilitado o valor da parcela será exibido sem juros 
          porém os juros serão amortizados do saldo devedor*/

          const entryPriceTable = simulatorData.amortization_system.find(e => e.type === "entry");
          if (entryPriceTable !== undefined) {
            await calculatePricePayments(
              entryParcel,
              currentTax,
              selectedEntryTerm
            ).then((res) => {
              //              console.log("Price: ", res);
              if (simulatorData.installments_interest_entry) {
                setEntryParcelsTable(res.payments);
                setEntryParcelValue(formatCurrency(res.payments[0].payment.toString()));
              } else {
                const entryParcelCalculatedValue = parseFloat(entryParcel) / selectedEntryTerm;
                setEntryParcelValue(formatCurrency(entryParcelCalculatedValue));
                const payments = Array.from({ length: selectedEntryTerm }, (_, i) => {
                  const payment = entryParcelCalculatedValue.toFixed(2);
                  return {
                    installment: `${i + 1} X`,
                    payment: payment,
                    total: payment
                  };
                });
                setEntryParcelsTable(payments);
              }
              setEntryInterest(parseFloat(res.totalInterest));
              setEntryParcelCalc(entryParcel + parseFloat(res.totalInterest));
            });
          } else {
            await calculateSimpleInterestPayment(
              entryParcel,
              currentTax,
              selectedEntryTerm
            ).then((res) => {
              //              console.log("Simple Interest: ", res);

              if (simulatorData.installments_interest_entry) {
                setEntryParcelsTable(res.payments);
                setEntryParcelValue(formatCurrency(res.payments[0].payment.toString()));
              } else {
                const entryParcelCalculatedValue = parseFloat(entryParcel) / selectedEntryTerm;
                setEntryParcelValue(formatCurrency(entryParcelCalculatedValue));
                const payments = Array.from({ length: selectedEntryTerm }, (_, i) => {
                  const payment = entryParcelCalculatedValue.toFixed(2);
                  return {
                    installment: `${i + 1} X`,
                    payment: payment,
                    total: payment
                  };
                });
                setEntryParcelsTable(payments);
              }
              setEntryInterest(parseFloat(res.totalInterest));
              setEntryParcelCalc(entryParcel + parseFloat(res.totalInterest));
            });
          }

          // const entryVp = await calculateVPPayments(entryParcel, currentTax, selectedEntryTerm);
          //          // console.log("Entry VP: ", entryVp);
          // setEntryParcelsTable("res.payments");
          // setEntryParcelValue(formatCurrency(entryParcel / selectedEntryTerm));
          // setEntryParcelCalc(entryParcel);
          // setEntryParcelsTable(entryVp.vpTable);
        }
      };

      fetchEntryValues();
    }
  }, [simulatorData, entryValue, selectedEntryTerm, selectedPricingTable]);

  const formatValue = (value) => parseFloat(value).toFixed(2);

  const calcularInstallmentsChoose = (data) => {
    // Calcular o número total de parcelas
    const totalParcelas = data.reduce((acc, row) => acc + row.quantidadeParcelas, 0);
    let currentSequence = 1;  // Inicializar o contador global de parcelas

    // Calcular o valor somado de todas as parcelas
    const valorSomadoDeTodasParcelas = data.reduce((acc, row) => acc + row.valorTotal * row.quantidadeParcelas, 0);

    const installments = data.map(row => {
      const { valorTotal, vencimento, intervaloDias, quantidadeParcelas, obs_sale } = row;

      // Validar valores
      if (valorTotal <= 0 || quantidadeParcelas <= 0) {
        toast.warn("Valor total e quantidade de parcelas devem ser maiores que 0");
        // throw new Error("Valor total e quantidade de parcelas devem ser maiores que 0");
      }

      // Garantir que a data de vencimento é um objeto Date
      const vencimentoDate = new Date(vencimento);

      // Calcular parcelas específicas do grupo
      return Array.from({ length: quantidadeParcelas }, (_, i) => ({
        value: (valorTotal).toFixed(2), // Formata o valor com duas casas decimais
        due_date: formatISO(addDays(vencimentoDate, i * intervaloDias)),
        sequence_number: `${i + 1}/${quantidadeParcelas}`, // Sequência local
        want_choose: 1,
        group_code: `${format(new Date(), "yyyyMMddHHmmss")}-${uuidv4()}`,
        obs_sale: obs_sale
      }));
    }).flat();

    // Ordenar installments por data
    installments.sort((a, b) => new Date(a.due_date) - new Date(b.due_date));

    // Extrair as duas primeiras datas de pagamento
    const primeiraDataPagamento = installments.length > 0 ? installments[0].due_date : null;
    const segundaDataPagamento = installments.length > 1 ? installments[1].due_date : null;

    return { installments, valorSomadoDeTodasParcelas, totalParcelas, primeiraDataPagamento, segundaDataPagamento };
  };

  useEffect(() => {
    if (chooseEntry) {
      try {
        const { installments, valorSomadoDeTodasParcelas, totalParcelas, primeiraDataPagamento, segundaDataPagamento } = calcularInstallmentsChoose(chooseEntryData);
        console.log("Data:", chooseEntryData);
        console.log("Installments:", installments);
        console.log("Valor Somado de Todas as Parcelas:", valorSomadoDeTodasParcelas);
        console.log("Número Total de Parcelas:", totalParcelas);
        console.log("Primeira Data de Pagamento:", primeiraDataPagamento);
        console.log("Segunda Data de Pagamento:", segundaDataPagamento);
        setEntryParcelsTable(installments)
        setChooseEntryInstallments(installments)
        setEntryValue(valorSomadoDeTodasParcelas)
        setEntryParcelCalc(valorSomadoDeTodasParcelas)
        setSelectedEntryTerm(totalParcelas)
        setFirstEntryParcelDate(primeiraDataPagamento)
        setOthersEntryParcelDate(segundaDataPagamento)
      } catch (error) {
        console.error(error.message)
      }
    }
  }, [chooseEntryData, landValue]);

  const addRow = () => {
    setChooseEntryData([...chooseEntryData, { id: chooseEntryData.length + 1, valorTotal: 0, vencimento: new Date(), intervaloDias: 30, quantidadeParcelas: 1, obs_sale: '' }]);
  };

  const deleteRow = (rowData) => {
    console.log("Delete chooseEntryData: ", chooseEntryData)
    if (chooseEntryData.length > 1) {
      setChooseEntryData(chooseEntryData.filter(d => d.id !== rowData.id));
    } else {
      toast.warning("Você precisa de ao menos uma linha para entrada.")
    }
  };

  const onCellEdit = (e, field) => {
    console.log(e)
    console.log(e.value)
    console.log(field)
    let updatedData = [...chooseEntryData];
    if (field === 'intervaloDias' || field === 'quantidadeParcelas') {
      updatedData[e.rowIndex][field] = parseInt(e.value);
    } else if (field === 'valorTotal') {
      updatedData[e.rowIndex][field] = parseFloat(e.value);
    } else {
      updatedData[e.rowIndex][field] = e.value;
      console.log(updatedData[e.rowIndex][field])
      console.log(e.value)
    }
    console.log(updatedData)
    setChooseEntryData(updatedData);
  };

  const valorTotalEditor = (options) => {
    return (
      <InputNumber
        value={options.value || ''}
        onValueChange={(e) => onCellEdit({ ...options, value: e.value }, 'valorTotal')}
        mode="currency"
        currency="BRL"
        locale="pt-BR"
        useGrouping={true}
        max={landValue}
      />
    );
  };

  const vencimentoEditor = (options) => {
    return <Calendar value={options.value} dateFormat={"dd/mm/yy"} mask="99/99/9999" locale="pt" onChange={(e) => onCellEdit({ ...options, value: e.value }, 'vencimento')} />;
  };

  // Editor para o campo intervaloDias
  const intervaloDiasEditor = (options) => {
    return (
      <InputNumber
        value={options.value || ''}
        onValueChange={(e) => onCellEdit({ ...options, value: e.value }, 'intervaloDias')}
        min={1}
        mode="decimal"
      />
    );
  };

  // Editor para o campo quantidadeParcelas
  const quantidadeParcelasEditor = (options) => {
    return (
      <InputNumber
        value={options.value || ''}
        onValueChange={(e) => onCellEdit({ ...options, value: e.value }, 'quantidadeParcelas')}
        min={1}
        mode="decimal"
      />
    );
  };

  const obsParcelasEditor = (options) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        onKeyDown={(e) => e.stopPropagation()}
        onBlur={(e) => onCellEdit({ ...options, value: e.target.value }, 'obs_sale')}
      />
    );
  };

  const actionBodyTemplate = (rowData) => {
    return <Button icon="pi pi-times" className="p-button-danger" onClick={() => deleteRow(rowData)} />;
  };

  return (
    <>
      {!chooseEntry ? (
        <div className="row">
          <div className="col-xl-3 col-md-12 pb-2">
            <label htmlFor="entrada">Valor Entrada</label>
            <InputNumber
              inputId="entrada"
              value={entryValue}
              onValueChange={(e) => {
                setEntryValue(e.value);
                setEntryRange(e.value * 100);
              }}
              mode="currency"
              currency="BRL"
              locale="pt-BR"
              useGrouping={true}
              min={minEntryValue}
              max={landValue}
              className="input"
            />
            <input
              type="range"
              className="w-100"
              value={entryRange}
              onChange={(e) => {
                setEntryValue(e.target.value / 100);
                setEntryRange(e.target.value);
              }}
              min={minEntryValue * 100}
              max={landValue * 100}
              step={1000}
            />
          </div>
          <div className="col-xl-3 col-md-12 pb-2">
            <label className="mb-3">Parcelas de Entrada</label>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: 18,
                border: "1px solid #ced4da",
                borderRadius: 8,
                margin: 0,
                justifyContent: "space-between",
              }}
            >
              <Dropdown
                value={selectedEntryTerm}
                onChange={(e) => setSelectedEntryTerm(e.value)}
                options={entryTerms}
                optionLabel="label"
                placeholder="1 X"
                className="border-0 bg-none px-0"
              />
              <span className="mx-auto">{entryParcelValue}</span>
            </div>
          </div>
          <div className="col-xl-3 col-md-12 pb-2">
            <label className="mb-3">Data Primeira Parcela</label>
            <Calendar
              value={firstEntryParcelDate}
              onChange={(e) => setFirstEntryParcelDate(e.value)}
              dateFormat={"dd/mm/yy"}
              mask="99/99/9999"
              className="w-100"
              locale="pt"
              // minDate={new Date()}
            />
          </div>
          {selectedEntryTerm > 1 && (
            <div className="col-xl-3 col-md-12 pb-2">
              <label className="mb-3">Data Demais Parcelas</label>
              <Calendar
                value={othersEntryParcelDate}
                onChange={(e) => setOthersEntryParcelDate(e.value)}
                dateFormat={"dd/mm/yy"}
                mask="99/99/9999"
                className="w-100"
                locale="pt"
                {...(firstEntryParcelDate && { minDate: new Date(firstEntryParcelDate) })}
              />
            </div>
          )}
        </div>
      ) : (
        <div className="row">
          <div className="col-12">
            <Button label="Adicionar Linha" icon="pi pi-plus" onClick={addRow} className="mb-4" />
            <div className="card p-fluid">
              <DataTable value={chooseEntryData} editMode="cell">
                <Column field="valorTotal" header="Valor Total" editor={valorTotalEditor} body={(rowData) => formatCurrency(rowData.valorTotal)} />
                <Column field="vencimento" header="Vencimento 1 Parcela" editor={vencimentoEditor} body={(rowData) => rowData.vencimento.toLocaleDateString("pt-BR")} />
                <Column field="quantidadeParcelas" header="Quantidade Parcelas" editor={quantidadeParcelasEditor} />
                <Column field="obs_sale" header="Observação Parcela" editor={obsParcelasEditor} />
                <Column field="intervaloDias" header="Intervalo Dias" editor={intervaloDiasEditor} />
                <Column body={actionBodyTemplate} header="Ação" />
              </DataTable>
            </div>
          </div>
        </div>
      )
      }
    </>
  );
};

export default EntryInstallments;
